import { useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';
import { useSubcontractorProfile } from '@/contexts/SubcontractorProfileContext';
import { refreshPushTokenForAdmin } from '@/lib/pushNotifications';

// Headless. Keeps admins.fcm_token current on every admin-portal open for
// devices that already granted notification permission (no prompt, no UI) —
// the mirror of PushTokenRefresher on the crew side.
//
// Until this existed an admin could not be reached on their phone at all:
// admins had no token column and the sender had no admin target, so every
// "tell the office" path ended at a screen someone had to be looking at.
const AdminPushTokenRefresher = () => {
  const { profile } = useSubcontractorProfile();
  const isAdmin = profile?.role === 'admin';

  useEffect(() => {
    if (isAdmin) refreshPushTokenForAdmin();
  }, [isAdmin]);

  return null;
};

export default AdminPushTokenRefresher;
